import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";

import { useUser } from "@/modules/shared/hooks/use-user";

import "./welcome-page.scss";

const DURATION_MS = 5_000;

const WelcomePage: React.FC = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const walletAddedToBackend = !!Object.keys(user?.wallets || {}).length;

  const [runKey, setRunKey] = useState(0);
  const shrinkerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setRunKey((k) => k + 1);
  }, []);

  const onAnimationEnd = useCallback(() => {
    navigate("/reputation", { replace: true });
  }, [walletAddedToBackend, navigate]);

  return (
    <div className="welcome-page">
      <img
        alt="#"
        className="welcome-page__logo"
        src="https://statica.thelargest.site/story/logo.svg"
      />

      <div
        aria-label="Loading"
        aria-valuemax={100}
        aria-valuemin={0}
        className="progress"
        role="progressbar"
      >
        <div className="progress__base" />

        <div
          key={runKey}
          ref={shrinkerRef}
          className="progress__mask progress__mask--animate"
          onAnimationEnd={onAnimationEnd}
          style={{ ["--duration" as any]: `${DURATION_MS}ms` }}
        />
      </div>
    </div>
  );
};

export { WelcomePage };
